<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="patch-notes">
  <h1 class="page-title">Gallery Patch Notes</h1>

  <div class="version-selector" *ngIf="index.length > 0">
    <mat-form-field appearance="outline">
      <mat-label>Version</mat-label>
      <mat-select [(value)]="selectedVersion" (selectionChange)="loadVersion($event.value)">
        <mat-option *ngFor="let entry of index" [value]="entry.version">
          {{ entry.version }} — {{ entry.tag }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="state-message" *ngIf="loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <div class="state-message error" *ngIf="error && !loading">
    <mat-icon>error_outline</mat-icon>
    <span>Failed to load patch notes.</span>
  </div>

  <section class="release" *ngIf="notes && !loading && !error">
    <div class="release-header">
      <span class="release-version">Version {{ notes.version }}</span>
      <span class="release-tag">{{ notes.tag }}</span>
      <span class="release-date">{{ notes.date | date : 'MMMM d, yyyy' }}</span>
    </div>

    <div class="category" *ngFor="let category of notes.categories">
      <h2 class="category-heading">{{ category.name }}</h2>
      <ul>
        <li *ngFor="let entry of category.entries">
          <span class="entry-title">{{ entry.title }}</span>
          <span class="entry-body">{{ entry.body }}</span>
        </li>
      </ul>
    </div>
  </section>
</div>
